import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { RuntimeConfigService } from '../config/runtime-config.service';
import { DeviceIdService } from '../device/device-id.service';

@Injectable({ providedIn: 'root' })
export class DeviceIdInterceptor implements HttpInterceptor {
  constructor(
    private runtimeConfig: RuntimeConfigService,
    private deviceId: DeviceIdService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isApiCall(req.url) || req.headers.has(this.deviceId.headerName())) {
      return next.handle(req);
    }
    return next.handle(req.clone({
      setHeaders: { [this.deviceId.headerName()]: this.deviceId.getId() },
    }));
  }

  private isApiCall(url: string): boolean {
    const base = this.runtimeConfig.apiBaseUrl;
    if (!base) return false;
    if (url.startsWith(base)) return true;
    if (base === '/api' && url.startsWith('/api/')) return true;
    return false;
  }
}
